import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { Calculator } from './components/Calculator/Calculator';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { FloorTypes } from './components/FloorTypes';
import { IncludedSection } from './components/IncludedSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ProcessSection } from './components/ProcessSection';
import { VideoSection } from './components/VideoSection';
import { UpsellSection } from './components/UpsellSection';
import { GallerySection } from './components/GallerySection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { WhatsAppFab } from './components/WhatsAppFab';
interface AppProps {
  /** Where the calculator sits relative to the narrative sections. */
  calculatorPlacement?: 'after-hero' | 'after-solution';
  /** Show the before/after projects gallery. */
  showGallery?: boolean;
  /** Show the packs upsell section. */
  showUpsell?: boolean;
}
export function App({
  calculatorPlacement = 'after-hero',
  showGallery = true,
  showUpsell = true
}: AppProps) {
  const calculator = <Calculator data-id="element-0" data-mp="7sxpp6lk59z" />;
  return <div className="min-h-full w-full bg-cream" data-id="element-1" data-mp="2zlv6ktmtuzuj">
      <Header data-id="element-2" data-mp="2zn6actg9w7ln" />
      <main data-id="element-3" data-mp="2znfyebhrc4op">
        <Hero data-id="element-4" data-mp="33mf2jtvnzxf3" />
        <TrustBar data-id="element-5" data-mp="33lwxq8uxsavk" />
        {calculatorPlacement === 'after-hero' && calculator}
        <ProblemSection data-id="element-6" data-mp="38m1gy6n8bjph" />
        <SolutionSection data-id="element-7" data-mp="38li619vzxvky" />
        {calculatorPlacement === 'after-solution' && calculator}
        <FloorTypes data-id="element-8" data-mp="3dl4lzr37lpxg" />
        <IncludedSection data-id="element-9" data-mp="3dlns8ajhypvn" />
        <ComparisonSection data-id="element-10" data-mp="3dirtwl3qlz6o" />
        <ProcessSection data-id="element-11" data-mp="nvsup6ui4rx0" />
        <VideoSection data-id="element-12" data-mp="nuhg0bzipzr4" />
        {showUpsell && <UpsellSection data-id="element-13" data-mp="nxn5vtfz15nw" />}
        {showGallery && <GallerySection data-id="element-14" data-mp="su44jhksr2f8" />}
        <FaqSection data-id="element-15" data-mp="stc9c7v436ph" />
        <FinalCta data-id="element-16" data-mp="sssrer5goibg" />
      </main>
      <Footer data-id="element-17" data-mp="36hvn4muyo06" />
      <WhatsAppFab data-id="element-18" data-mp="35yomiyqxk0x" />
    </div>;
}